import CrudTable, { TextField, TextArea, CheckField, JsonField, ImageField, SelectField } from './CrudTable';

const CATEGORIES = ['SaaS', 'Fintech', 'Health', 'E-commerce', 'Education', 'Real Estate', 'Travel', 'Media'];

export default function AdminProjects() {
  return (
    <CrudTable
      table="projects"
      title="Portfolio"
      itemLabel="portfolio item"
      publicPath={it => it.slug ? `/portfolio/${it.slug}` : null}
      defaults={{ slug: '', title: '', category: 'SaaS', tagline: '', cover: '', metrics: [], color: '#14B8B5', featured: true, order_index: 0, problem: '', solution: '', deliverables: [], services_used: '', year: new Date().getFullYear().toString(), research: '', outcomes: '', meta_title: '', meta_description: '' }}
      columns={[
        { key: 'title', label: 'Title' },
        { key: 'category', label: 'Category', className: 'col-span-2' },
        { key: 'slug', label: 'Slug', className: 'col-span-2' },
        { key: 'featured', label: 'Featured', className: 'col-span-2', format: v => v ? 'Yes' : 'No' },
      ]}
      render={(it, set) => (
        <>
          <TextField label="Title" value={it.title} onChange={v => set({ ...it, title: v })} required />
          <TextField label="Slug" value={it.slug} onChange={v => set({ ...it, slug: v })} required />
          <TextField label="Tagline" value={it.tagline} onChange={v => set({ ...it, tagline: v })} />
          <SelectField label="Category" value={it.category} options={CATEGORIES} onChange={v => set({ ...it, category: v })} />
          <ImageField label="Cover image" folder="projects" value={it.cover} onChange={v => set({ ...it, cover: v })} />
          <TextField label="Accent color" value={it.color} onChange={v => set({ ...it, color: v })} />
          <JsonField label="Metrics" value={it.metrics} onChange={v => set({ ...it, metrics: v })} />
          <TextArea label="Problem (challenge)" value={it.problem} onChange={v => set({ ...it, problem: v })} />
          <TextArea label="Solution" value={it.solution} onChange={v => set({ ...it, solution: v })} rows={6} />
          <JsonField label="Deliverables — list of capability strings shown in Design & engineering" value={it.deliverables} onChange={v => set({ ...it, deliverables: v })} />
          <TextField label="Services used (e.g. Brand, Web Design, Web Development)" value={it.services_used} onChange={v => set({ ...it, services_used: v })} />
          <TextField label="Year" value={it.year} onChange={v => set({ ...it, year: v })} />
          <TextArea label="Research & strategy" value={it.research} onChange={v => set({ ...it, research: v })} rows={3} />
          <TextArea label="Outcomes summary" value={it.outcomes} onChange={v => set({ ...it, outcomes: v })} rows={3} />
          <CheckField label="Featured" value={it.featured} onChange={v => set({ ...it, featured: v })} />
          <TextField label="Order" type="number" value={it.order_index} onChange={v => set({ ...it, order_index: v })} />
          <div className="border-t border-ink-100 pt-4">
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-ink-400">SEO (optional — falls back to title/tagline if left blank)</p>
          </div>
          <TextField label="Meta title" value={it.meta_title} onChange={v => set({ ...it, meta_title: v })} />
          <TextArea label="Meta description" value={it.meta_description} onChange={v => set({ ...it, meta_description: v })} rows={2} />
        </>
      )}
    />
  );
}
